import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
import $ from 'jquery';
class Masters extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            hiring_profile: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            search: '',
            loading: 1,
            activePage: 1,
            startDate: '',
            endDate: '',
            fields: {},
            errors: {},
            item_count: '',
            isLoadMore: 1,
            fromdate: '',
            registered_mail: '',
            todate: '',
        };
        this.onChange = this.onChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
    }

    spaceKeyPress(event) {
        if (event.which == 32 && !event.target.value.length) {
            event.preventDefault();
        }
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        if (!fields["search"]) {
            formIsValid = false;
            errors["search"] = "This field is required.";
            this.setState({ registered_mail: "" })
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/HrmanagementRest/GetHiringProfile/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        hiring_profile: findresponse.hiring_profile,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }

    }

    profileList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/GetHiringProfile/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    hiring_profile: findresponse.hiring_profile,
                    loading: 0,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    item_count: findresponse.item_count,
                    setPage: 'yes',
                    hr_permission: findresponse.hr_permission,
                })
            })
    }

    insertProfile() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("insert_designation").innerHTML = "Submitting....";
        const fd = new FormData;
        //document.getElementById("insert_designation").disabled = true;					 
        fd.append('hiring_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/InsertProfile/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("insert_designation").innerHTML = "Add";
                if (findresponse.code == 200) {
                    window.location.href = '/masters';
                }
                else if (findresponse.code == 700) {
                    this.setState({ registered_mail: findresponse.msg }, function () {
                    });
                }
            })
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/HrmanagementRest/GetHiringProfile/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.hiring_profile.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }

                this.setState({
                    //isLoadMore:1,
                    hiring_profile: this.state.hiring_profile.concat(findresponse.hiring_profile),
                })
            })
    }


    delete_profile(id) {
        if (window.confirm('Are you sure you want to delete ?')) {
            fetch(this.state.apiUrl + '/HrmanagementRest/ProfileDelete/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    this.setState({
                        activePage: 1,
                        hiring_profile: [],
                    },
                        function () {
                            this.profileList(this.state.activePage);
                        })
                })
        }
    }

    getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head row">
                            <li class="col-md-11">Designation</li>
                            <li class="col-md-1">
                                <div class=" text-center">
                                    Actions
                    </div>
                            </li>
                        </ul>
                        {
                            this.state.hiring_profile.map((hiring_profile, key) =>
                                <ul class="tickets_number row">
                                    <li class="col-md-11">{hiring_profile.name}</li>
                                    <li class="col-md-1">
                                        <div class="edit_delete text-center">
                                            <span class="delete" onClick={() => this.delete_profile(hiring_profile.id)}><i class="fa fa-trash" aria-hidden="true"></i></span>
                                        </div>
                                    </li>

                                </ul>
                            )
                        }
                    </div>
                    {
                        this.state.hiring_profile.map((hiring_profile, key) =>
                            <div class="customer_mob hidden-md">
                                <div class="custmer_list_mob designation">
                                    <div>{hiring_profile.name ? hiring_profile.name : '--'}</div>
                                    <div tabindex="0" class="onclick-menu pull-right">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        <ul class="onclick-menu-content">
                                            <li onClick={() => this.delete_profile(hiring_profile.id)}><a>Delete</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            )
        }
    }

    componentDidMount() {
        document.title = "Intranet | Masters";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.profileList();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        if (this.state.hr_permission == 'no') {
            return (
                        <Redirect to={'/home'} />
                    )
        }
        return (
                
            <div>
                <Header brecum_name="Masters" brecum_page="Masters" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-md"><HeaderMob page_name="Masters" /></div>
                        <div class="title">
                            <span>Masters</span>
                        </div>
                        <div class="row intra_form emp_mob">
                            <div class="col-md-6 col-xs-12">
                                <div class="form-group row">
                                    <div class="col-sm-9 col-xs-12">
                                        <div class="searchMaster emp_dept">
                                            <input type="text" name="search" placeholder="Enter Designation" class="form-control" onKeyPress={this.spaceKeyPress} onChange={this.onChange} /><button id="insert_designation" type="submit" onClick={() => this.insertProfile()} >Add</button>
                                        </div>
                                        <span class="error">{this.state.registered_mail}</span>
                                        <span class="error">{this.state.errors["search"]}</span>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        )
    }
}
export default Masters;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/masters.js